import React, {Component} from 'react';
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import {Stack, Tooltip} from "@mui/material";
import {StyledTypography} from "./StyledComponents";
import {getZStackUrl} from "../../bloodviewer/utils/fieldUtils";
import {addKeyboardListener, addWheelListener, removeKeyboardListeners} from "../../../utils/listeners";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {convertSettingsToFilter} from "../../../utils/utils";
import {bloodClass, bloodImageProperties} from "../../../utils/const";

class Field100xImage extends Component {

    constructor(props) {
        super(props);

        this.minZoom = 100;
        this.maxZoom = 800;
        this.fld100xRef = React.createRef();

        this.state = this.initState();
        this.imageRef = React.createRef();
    }

    initState = () => {
        if (this.props.annotation) {
            this.meta = this.props.annotation.meta && typeof this.props.annotation.meta === 'string' ?
                JSON.parse(this.props.annotation.meta) : this.props.annotation.meta;

            // Explicitly setting this to null, works for first load
            this.prevImage = null

            return {
                zStack: this.meta.initZStack || 0,
                zoom: this.minZoom,
                scrollDisabled: false,
                loaded: false,
                annotations: [],
                pageRefresh: false,
                resetOnFirstLoad: true,
                loadingImage: false,
            }
        }
    }

    componentDidMount() {
        addKeyboardListener(document, this.keyDownListener, this.keyUpListener);
        addWheelListener(document, this.onWheel);

        this.timer = setTimeout(() => {
            this.setState({resetOnFirstLoad: true});
        }, 2000);

        if (this.state?.resetOnFirstLoad === true) {
            this.reposition();
            this.setState({resetOnFirstLoad: false});
        }
    }

    componentWillUnmount() {
        removeKeyboardListeners(document, this.keyDownListener);
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.annotation.id !== this.props.annotation.id)
            this.setState(this.initState());
        if (prevProps.scale !== this.props.scale)
            this.imageRef.current.centerView(this.convertZoomToScale(this.minZoom));

        if (prevProps.annotation.meta === undefined && this.props.annotation.meta !== undefined) {
            this.timer = setTimeout(() => {
                this.setState({resetOnFirstLoad: true});
            }, 1000);
        }
        if (this.state?.resetOnFirstLoad === true) {
            this.reposition();
            this.setState({resetOnFirstLoad: false});
        }

        if (prevProps.annotation !== this.props.annotation) {
            this.reposition();
            if (prevProps.annotation.image !== this.props.annotation.image) {
                this.setState({
                    loadingImage: true
                });
            } else if (this.props.mode === bloodClass.WBC) {
                this.setState({
                    loadingImage: true
                });
            }
            if (this.props.annotation.meta && this.props.mode === bloodClass.WBC) {
                this.setState({
                    annotations:
                        [{
                            "geometry": {
                                "type": "RECTANGLE",
                                "x": (this.props.annotation.meta['initPos'][0] / bloodImageProperties.WIDTH * 100) - 12,
                                "y": (this.props.annotation.meta['initPos'][1] / bloodImageProperties.HEIGHT * 100) - 12,
                                "width": 24,
                                "height": 24,
                            },
                            "data": {
                                "text": <span
                                    style={{color: "black", fontSize: "2.5vw"}}>{this.props.annotation.class}</span>,
                                "id": Math.random()
                            },
                        }]
                });
            }
        }
        if (prevProps.annotation.id !== this.props.annotation.id) {
            this.setState({
                image_updated: true,
            })
        }
    }

    keyDownListener = (event) => {
        if (event.target.tagName === 'INPUT' || event.ctrlKey || event.altKey)
            return;
        switch (event.code) {
            case "Shift":
            case "ShiftLeft":
            case "ShiftRight":
                this.state.zoomDisabled || this.setState({zoomDisabled: true});
                break;
            default:
                break;
        }
    }

    keyUpListener = (event) => {
        if (event.target.tagName === 'INPUT' || event.ctrlKey || event.altKey)
            return;
        switch (event.key) {
            case "Shift":
            case "ShiftLeft":
            case "ShiftRight":
                this.state.zoomDisabled && this.setState({zoomDisabled: false});
                break;
            default:
                break;
        }
    }

    async reposition() {
        if (this.props.mode === bloodClass.WBC || this.props.mode === bloodClass.RBC || this.props.mode === bloodClass.PLT) {
            this.positionAndZoom();
            return;
        }
        if (this.props.mode === bloodClass.FIELD) {
            this.resetPosition();
        }
    }

    resetPosition = () => {
        this.setState({
            image_updated: false,
        })
        if (this.imageRef && this.imageRef.current) {
            let x = ((2 * (document.documentElement.clientWidth))) / 100
            let y = document.documentElement.clientHeight / 8
            this.imageRef.current.setTransform(x, y, document.documentElement.clientWidth * 0.00016)
            setTimeout(() => {
                this.setState({pageRefresh: !this.state.pageRefresh})
            }, 1000) //used to update zoom level display on top of image
        }
    }

    positionAndZoom = () => {

        // CHANGE MAGNIFICATION OF IMAGE ONLY THROUGH 'MAG' VARIABLE!!
        let MAG = 0.334; //Value taken so that initial Load of WBC shows 100x

        if (this.imageRef && this.imageRef.current && this.props.annotation.meta['initPos']) {
            let yoffset = this.fld100xRef.current.clientHeight / 2;
            let xoffset = this.fld100xRef.current.clientWidth / 2;
            this.imageRef.current.setTransform((-(this.props.annotation.meta['initPos'][0]) * MAG) + xoffset, (-(this.props.annotation.meta['initPos'][1]) * MAG) + yoffset, MAG)
        }
        this.setState({
            image_updated: false,
        })
        setTimeout(() => {
            this.setState({pageRefresh: !this.state.pageRefresh})
        }, 1000) //used to update zoom level display on top of image
    }

    convertZoomToScale = (zoom) => zoom / (500 / this.props.scale);

    convertScaleToZoom = (scale) => scale * 500 / this.props.scale;

    //[Priyanshu] compare zStack only with undefined, as 0 is false.
    setZStack = (zStack) => zStack !== undefined ? this.setState({zStack}) : null;

    higherZstack = () => this.setZStack(this.meta.ZStacks[this.meta.ZStacks.indexOf(this.state.zStack) + 1]);

    lowerZstack = () => this.setZStack(this.meta.ZStacks[this.meta.ZStacks.indexOf(this.state.zStack) - 1]);

    zoomIn = (ref) => {
        ref = ref || this.imageRef.current;
        let zoom = Math.min(this.state.zoom * 1.2, this.maxZoom);
        ref.centerView(this.convertZoomToScale(zoom));
        this.setState({zoom});
    }

    zoomOut = (ref) => {
        ref = ref || this.imageRef.current;
        let zoom = Math.max(this.state.zoom * 0.8, this.minZoom);
        ref.centerView(this.convertZoomToScale(zoom));
        this.setState({zoom});
    }

    onWheel = (event) =>
        this.state.zoomDisabled && event.target === this.imageRef.current.instance.contentComponent &&
        (event.wheelDeltaY > 0 ? this.higherZstack() : this.lowerZstack());

    onImageLoad = () => {
        if (!this.state.scrollDisabled && this.prevImage !== this.props.annotation.image) {
            this.imageRef.current.centerView(this.convertZoomToScale(this.minZoom))
            this.prevImage = this.props.annotation.image
        }
        this.setState({loaded: true})
    }

    handleImageLoaded() {
        this.setState({
            loadingImage: false
        })
    }

    render() {
        let zStackMicrons = (this.state.zStack * this.meta.ZStackStep).toFixed(2);
        const antIcon = <LoadingOutlined style={{fontSize: 0}} spin/>;
        return <Spin indicator={antIcon} spinning={!this.state.loaded} wrapperClassName={'full-parent'}>
            <TransformWrapper ref={this.imageRef} initialScale={this.convertZoomToScale(this.minZoom)}
                              wheel={{
                                  step: 0.3,
                                  disabled: this.state.zoomDisabled,
                              }}
                              minScale={this.convertZoomToScale(this.minZoom)}
                              maxScale={this.convertZoomToScale(this.maxZoom)}
                              onZoomStop={context =>
                                  this.setState({zoom: this.convertScaleToZoom(context.state.scale)})}>
                <TransformComponent wrapperStyle={{
                    borderStyle: 'solid', borderWidth: '4px', width: '100%',
                    height: '100%', borderColor: this.props.selected ? '#32c730' : '#03112c',
                    backgroundColor: '#03112c'
                }}>
                    <img
                        src={getZStackUrl(this.props.annotation.image, this.state.zStack)}
                        style={{
                            filter: convertSettingsToFilter(this.props.cssfilter),
                        }}
                        alt={""}
                        onLoad={this.onImageLoad}
                    />
                </TransformComponent>
                <Stack sx={{position: 'relative', bottom: '5vh'}} direction={"row"}
                       justifyContent={"space-around"} className={"full-width"}>
                    <Tooltip title={'Scroll/pinch to zoom in/out'} placement={'top'}>
                        <StyledTypography>{this.state.zoom.toFixed(0)} X</StyledTypography>
                    </Tooltip>
                    <Tooltip title={'Shift + Scroll/pinch to toggle Z Stack up/down'} placement={'top'}>
                        <StyledTypography>{zStackMicrons >= 0 ? "+" + zStackMicrons : zStackMicrons} μm</StyledTypography>
                    </Tooltip>
                </Stack>
            </TransformWrapper>
        </Spin>
    }
}

export default Field100xImage;
